import { render, staticRenderFns } from "./SettingsTable.vue?vue&type=template&id=0c0e7c14&scoped=true"
import script from "./SettingsTable.vue?vue&type=script&lang=js"
export * from "./SettingsTable.vue?vue&type=script&lang=js"
import style0 from "./SettingsTable.vue?vue&type=style&index=0&id=0c0e7c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e7c14",
  null
  
)

export default component.exports